<template>
    <!-- Phones: a fullscreen dialog. Elsewhere: a 400 px menu under the bell.
         docs/notification-bell-proposal.md §4.4 -->
    <v-dialog v-if="isPhone" v-model="store.panel_open" fullscreen transition="dialog-bottom-transition">
        <template v-slot:activator="{ props }">
            <BellActivator v-bind="props" :listitem="listitem" :count="store.unread_count" :label="t('notifications')" />
        </template>
        <v-card class="d-flex flex-column noti-phone">
            <v-toolbar density="comfortable" color="surface" class="noti-phone-bar">
                <v-btn icon="mdi-close" variant="text" :aria-label="t('close')" @click="store.panel_open = false" />
                <v-toolbar-title>{{ t("notifications") }}</v-toolbar-title>
                <v-btn icon="mdi-check-all" variant="text" :disabled="!store.unread_count"
                    :aria-label="t('mark_all_as_read')" @click="store.markAllRead()" />
            </v-toolbar>
            <NotificationList @opened="store.panel_open = false" />
        </v-card>
    </v-dialog>

    <v-menu v-else v-model="store.panel_open" :close-on-content-click="false"
        :location="listitem ? 'end top' : 'bottom'" offset="6">
        <template v-slot:activator="{ props }">
            <BellActivator v-bind="props" :listitem="listitem" :count="store.unread_count" :label="t('notifications')" />
        </template>
        <v-card class="d-flex flex-column noti-panel">
            <div class="noti-head d-flex align-center">
                <span class="text-subtitle-1 font-weight-medium flex-grow-1">{{ t("notifications") }}</span>
                <v-btn variant="text" color="accent" :disabled="!store.unread_count" @click="store.markAllRead()">
                    {{ t("mark_all_as_read") }}
                </v-btn>
            </div>
            <NotificationList @opened="store.panel_open = false" />
        </v-card>
    </v-menu>
</template>

<script setup>
import { watch } from 'vue'
import BellActivator from '@/components/notifications/BellActivator.vue'
import NotificationList from '@/components/notifications/NotificationList.vue'
import { useIsPhone } from '@/composables/display'
import { usePitStoreBasics } from '@/stores/app_common'
import { useNotificationsStore } from '@/stores/notifications'

defineProps({ listitem: { type: Boolean, default: false } })

const { t } = usePitStoreBasics()
const { isPhone } = useIsPhone()
const store = useNotificationsStore()

// The list is read when the panel opens, never in the background: the
// background only asks for the unread count.
watch(() => store.panel_open, (open) => {
    if (open) store.loadFirstPage()
})
</script>

<style scoped>
.noti-panel {
    width: 400px;
    max-width: calc(100vw - 32px);
    max-height: min(560px, calc(100vh - 80px));
}

.noti-head {
    flex: none;
    gap: 8px;
    padding: 8px 8px 8px 16px;
    border-bottom: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
}

.noti-phone {
    height: 100%;
}

.noti-phone-bar {
    flex: none;
    border-bottom: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
}
</style>
